import { type Breakpoint } from '@heidi/utils';
import { atom } from 'jotai';

export const windowIndexAtom = atom<number | undefined>(undefined);

export const isContextDebouncingAtom = atom(false);

export const isDocumentDebouncingAtom = atom(false);

export const scribeTabBreakpointAtom = atom<Breakpoint>('xl');

/**
 * Live size (percent, 0–100) of the left split-screen pane. Written by the split
 * canvas's ResizablePanelGroup on every resize and read by the header tab strips
 * so the two tab clusters track the divider as it moves. Defaults to an even 50.
 */
export const splitLeftSizeAtom = atom(50);
